/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Review_Annotations_TitleInputs */

const en_review_annotations_title = /** @type {(inputs: Review_Annotations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review Annotations`)
};

const de_review_annotations_title = /** @type {(inputs: Review_Annotations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmerkungen ansehen`)
};

/**
* | output |
* | --- |
* | "Review Annotations" |
*
* @param {Review_Annotations_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const review_annotations_title = /** @type {((inputs?: Review_Annotations_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Review_Annotations_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_review_annotations_title(inputs)
	return en_review_annotations_title(inputs)
});